import SVGVessel from "components/_common/icons/SVGVessel";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { vesselActions, vesselSelectors } from "redux/app/vessel";
import { vesselOnboardSelectors } from "redux/app/vessel/onboard";
import { IStore } from "redux/store";
import Select from "react-select";
import classNames from "classnames";
import clsx from "clsx";
import { TAB_IDS } from "redux/app/vessel/constants";
import { historyActions } from "redux/_core/history";
import { rootRoutes } from "routes";
import { vdmDashboardUtils } from "redux/app/vdmdashboard/utils";

const { getIsVDMVisible } = vdmDashboardUtils;

interface IOption {
	label: string;
	value: string;
}

const vesselDropdownStyles = {
	dropdownIndicator:
		"p-1 hover:bg-gray-100 text-gray-500 rounded-md hover:text-black",
	menu: "p-1.5 py-1.5 mt-2 border border-gray-200 bg-white rounded-lg",
	option: {
		base: "hover:cursor-pointer px-2.5 py-1.5 rounded",
		focus: "bg-[#3182CE14] active:bg-gray-200 cursor-pointer",
		selected: "bg-blue-100 text-blue-800",
	},
	control: {
		base: "border rounded-md bg-white hover:cursor-pointer px-2 min-w-[150px] xl:min-w-[175px] min-h-[36px] h-[36px]",
		focus: "border-primary-600 ring-1 ring-primary-500",
		nonFocus: "border-gray-300 hover:border-gray-400",
		disabled: "bg-gray-200 cursor-not-allowed",
	},
};

type OwnProps = {
	goBack?: () => void;
};
type VesselNameProps = PropsFromRedux & OwnProps;
function VesselName(props: VesselNameProps) {
	const { goBack, vessel, vesselsToShow, selectedTab, jobToLoadVessel, tenantId } = props;
	const [selectedVessel, setSelectedVessel] = useState<IOption | undefined>(
		undefined
	);

	const vesselOptions = vesselsToShow.ids.map((vesselId) => {
		const vesselDetails = vesselsToShow.byIds[vesselId];
		return {
			label: vesselDetails.vesselName,
			value: vesselId,
		};
	});

	useEffect(() => {
		if (vessel) {
			setSelectedVessel({ label: vessel.vesselName, value: vessel.id });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vessel?.id]);

	useEffect(() => {
		props.loadAllVessels(); // this to ensure all vessels are shown in vdm dashboard, when user navigates through myVessels.
		if (selectedTab === TAB_IDS.myVessels) {
			props.loadMyVessels();
		} 
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTab]);

	const isVDMVisible = getIsVDMVisible(tenantId);

	return (
		<div className="text-2xl font-light text-gray-600 align-baseline select-none font-redhat-display flex items-center">
			{goBack && (
				<span
					title="go back"
					onClick={() => goBack && goBack()}
					className="bp3-icon bp3-icon-arrow-left text-lg mr-3 cursor-pointer"
				/>
			)}
			<div className="flex items-center">
				<span className="hidden md:inline-block mx-4">
					<SVGVessel className="w-5 h-5 -mb-1" />{" "}
				</span>
				<Select
					id="vessel"
					isSearchable
					key={"vessel" + selectedVessel?.value}
					placeholder={"Search Vessels"}
					value={selectedVessel}
					isDisabled={jobToLoadVessel.isLoading}
					unstyled
					options={vesselOptions}
					onChange={(newValue, actionMeta) => {
						if (newValue?.value) {
							setSelectedVessel(newValue);
							isVDMVisible
								? props.onVDMClick(newValue.value)
								: props.onOnboardClick(newValue.value);
						}
					}}
					className={classNames("w-full text-sm", {
						"cursor-not-allowed": false,
					})}
					menuPosition="fixed"
					classNames={{
						dropdownIndicator: () => vesselDropdownStyles.dropdownIndicator,
						menu: () => vesselDropdownStyles.menu,
						option: ({ isFocused, isSelected }: any) =>
							clsx(
								isFocused && vesselDropdownStyles.option.focus,
								isSelected && vesselDropdownStyles.option.selected,
								vesselDropdownStyles.option.base
							),

						control: ({ isFocused, isDisabled }) =>
							clsx(
								vesselDropdownStyles.control.base,
								isFocused
									? vesselDropdownStyles.control.focus
									: vesselDropdownStyles.control.nonFocus,
								isDisabled
									? vesselDropdownStyles.control.disabled
									: vesselDropdownStyles.control.base
							),
						indicatorsContainer: () => "h-[36px]",
						valueContainer: ({ isDisabled }) =>
							clsx(
								"px-3 text-gray-800 font-medium",
								isDisabled && "bg-gray-100 ml-2"
							),
					}}
				/>
			</div>
			{/* <span className="inline-block mx-2">
				{jobToLoadVessel.isLoading ? (
					"Loading Vessel"
				) : (
					<>
						<span className="text-gray-400" title="Prefix">
							{vessel?.vesselPrefix} -
						</span>{" "}
						<span title="Vessel Name">{vessel?.vesselName}</span>
					</>
				)}
			</span> */}
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const onboardStore = vesselOnboardSelectors._getStore(store);
	const vesselId = vesselStore.onboard.vesselId ?? "";
	const vessel = vesselSelectors.getVesselById(
		vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const selectedTab = vesselSelectors.getSelectedTab(vesselStore);
	const { vessels } = vesselSelectors
		.vesselListSelectors(vesselStore)
		.getVesselListData();

	const jobToLoadVessel = vesselOnboardSelectors.jobToLoadVessel(onboardStore);
	return {
		vessel,
		// vesselsToShow: selectedTab === TAB_IDS.myVessels ? myVessels : vessels,
		vesselsToShow: vessels,
		selectedTab,
		jobToLoadVessel,
		tenantId: store.app.auth.user?.tenantId,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		loadAllVessels() {
			dispatch(vesselActions.listLoadAllVessels());
		},
		loadMyVessels() {
			dispatch(vesselActions.listMyVessels());
		},
		onVDMClick(vesselId: string) {
			dispatch(
				historyActions.push(
					"#VesselList",
					rootRoutes.children.app.children.vessel.children.onboard.children.vdmdashboard.children.portCalls.url(
						vesselId
					)
				)
			);
		},
		onOnboardClick(vesselId: string) {
			dispatch(
				historyActions.push(
					"#VesselList",
					rootRoutes.children.app.children.vessel.children.onboard.children.usage.url(
						vesselId
					)
				)
			);
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VesselName);
